/* ===========================
 * Patient Profile Transformer
 * ===========================
 *
 * The transformer for the patient profile
 */

import Transformer from './transformer';
import userTransformer from './user';

export default class PatientProfileTransformer extends Transformer {
  /**
   * Method used to transform a fetched profile
   *
   * @param profile The fetched profile
   *
   * @returns {Object} The transformed profile
   */
  static fetch(profile) {
    return {
      id: profile.id,
      user_id: profile.user_id,
      display_name: profile.display_name,
      owner: profile.owner,
      firstname: profile.firstname,
      lastname: profile.lastname,
      citizenid: profile.citizenid,
      birthdate: profile.birthdate,
      gender: profile.gender,
      address: profile.address,
      subdistrict: profile.subdistrict,
      district: profile.district,
      province: profile.province,
      postal_code: profile.postal_code,
      emergency_contact_name: profile.emergency_contact_name,
      emergency_contact_relationship: profile.emergency_contact_relationship,
      emergency_contact_tel: profile.emergency_contact_tel,
      diseases: profile.diseases,
      allergies: profile.allergies,
      medicines: profile.medicines,
      avatar: profile.avatar,
      // user: profile.user ? userTransformer.fetch(profile.user.data) : {}
      user: profile.user ? userTransformer.fetch(profile.user) : {},
    };
  }

  static fetchForTable(profile) {
    return {
      id: profile.id,
      user_id: profile.user_id,
      firstname: profile.firstname,
      lastname: profile.lastname,
      tel: profile.user.tel,
      email: profile.user.email,
      otp: profile.user.tel_verification_token,
      otp_created_at: profile.user.tel_verification_created,
      fullName: this.fullName(profile),
      support_pin: profile.user.support_pin,
      display_name: profile.display_name,
      citizenid: profile.citizenid,
      id_card_photo: profile.id_card_photo,
      privileges: profile.employee
        .filter((e) => e.active === true && e.organization.active === true)
        .map((e) => e.organization.name.replace('thailand', 'B2C')),
      emergency_contact: {
        name: profile.emergency_contact_name,
        relationship: profile.emergency_contact_relationship,
        tel: profile.emergency_contact_tel,
      },
      wallet: profile.user.wallet,
      employee: profile.employee,
    };
  }
  /**
   * Method used to transform a send profile
   *
   * @param profile The profile to be send
   *
   * @returns {Object} The transformed profile
   */
  // static send(profile) {
  //   return {
  //     id: profile.id,
  //     user_id: profile.user_id,
  //     owner: profile.owner,
  //     firstname: profile.firstname,
  //     lastname: profile.lastname,
  //     citizenid: profile.citizenid,
  //     birthdate: profile.birthdate,
  //     gender: profile.gender,
  //     diseases: profile.diseases,
  //     allergies: profile.allergies,
  //     medicines: profile.medicines,
  //   };
  // }

  static fullName(profile) {
    if (!profile) {
      return '';
    }

    if (!profile.firstname) {
      return '';
    }

    if (!profile.lastname) {
      return profile.firstname;
    }

    return `${profile.firstname} ${profile.lastname}`;
  }

  static shortName(profile) {
    if (!profile) {
      return '';
    }

    if (!profile.firstname) {
      return '';
    }

    if (!profile.lastname) {
      return profile.firstname;
    }

    return profile.firstname;
  }
}
